/* eslint-disable object-curly-newline */
const store = require('Store');
const Actions = require('actions/Actions');
const PromoActions = require('actions/PromoActions');
const addToCartPixels = require('analytics/addToCartPixels');
const UtilActions = require('utils/redux/Actions');
const Location = require('utils/Location');
const basketUtils = require('utils/Basket');
const userUtils = require('utils/User');
const decorators = require('utils/decorators');
const processEvent = require('analytics/processEvent');
const { LINK_TRACKING_EVENT, Event: { EVENT_71 } } = require('analytics/constants');
const checkoutConstants = require('components/Checkout/constants');
const basketApi = require('services/api/basket');
const localeUtils = require('utils/LanguageLocale');
const ErrorsUtils = require('utils/Errors');
const ERROR = 'error';
const PROMO_INVALID = 'basketLevelMsg';

function getBasicAnalyticsData(promoCode, isError = false) {
    let appliedPromos = Promos.getAppliedPromoCodes();
    appliedPromos.push(promoCode);
    return {
        eventStrings: [EVENT_71],
        linkName: isError ? 'Error' : 'Enter Promo Code',
        actionInfo: 'Enter Promo Code',
        userInput: appliedPromos.join(',').toLowerCase()
    };
}

function sendBrazePromoCodeEvent(promoCode) {
    // Send a custom braze event when a promo code is redeemed on qualifying SKUS
    // Send a custom braze property including the promo code used

    // Check if code is not CBR/CCR/RRC
    if (Promos.getPromoType(promoCode) === Promos.PROMO_TYPES.PROMO &&
        !Promos.isRrcPromoCode(promoCode)) {
        global.appboy && appboy.logCustomEvent(
            'promocodeRedeemed',
            { 'promocode': promoCode }
        );
    }
}

function submitMsgPromotions(couponCode) {
    const promo = store.getState().promo;
    const sampleSkuIdList = promo.msgPromosSkuList
        .filter(elem => elem.couponCode === couponCode)
        .map(elem => elem.skuId);

    if (sampleSkuIdList && sampleSkuIdList.length > 0) {
        decorators.withInterstice(
            basketApi.addMsgPromotionToBasket,
            checkoutConstants.INTERSTICE_DELAY_MS
        )(couponCode, sampleSkuIdList)
            .then(data => {
                const BasketActions = require('actions/BasketActions');
                data.promoWarning = !data.promoWarning ? null : data.promoWarning;
                store.dispatch(BasketActions.updateBasket(data));
                processEvent.process(LINK_TRACKING_EVENT, { data: getBasicAnalyticsData(couponCode) });
                return new Promise((resolve)=>{
                    resolve(data);
                });
            })
            .catch(reason => {
                store.dispatch(PromoActions.removeMsgPromosByCode(couponCode));
                store.dispatch(UtilActions.merge('promo', 'promoError', Object.assign({}, reason, {
                    promoCode: couponCode
                })));
                return new Promise((resolve, reject)=>{
                    reject(reason);
                });
            });
    }
}

function showPromoConfirmationModal() {
    let getPromoText = localeUtils.getLocaleResourceFile('utils/locales', 'Promos');
    const title = getPromoText('promoConfirmationTitle');
    const message = getPromoText('promoConfirmationMessage');
    const buttonText = getPromoText('ok');
    store.dispatch(Actions.showInfoModal({
        isOpen: true,
        title,
        message,
        showCancelButton: false,
        isHtml: false,
        buttonText
    }));
}

function applyPromotion(promoCode, captchaToken, appliedAt = Promos.CTA_TYPES.TEXT, isBccPromotionComponent = false, titleText = false) {
    let getText = localeUtils.getLocaleResourceFile('utils/locales', 'Promos');
    const isMobile = Sephora.isMobile();

    store.dispatch(Actions.showMediaModal({ isOpen: false }));

    let promoPopUpErrorMessages = [];
    const BasketActions = require('actions/BasketActions');
    const isBasketOrCheckoutPage = Location.isBasketPage() || Location.isCheckout();

    return basketApi.applyPromotion(promoCode, captchaToken)
        .then(data => {
            const { responseStatus, items, maxMsgSkusToSelect, instructions, appliedPromotions, basketLevelMessages } = data;

            if (responseStatus === 202) {
                const location = Location.isCheckout() ? 'checkout' : null;
                // 202 is a responseStatus for MSG promo
                Promos.sendBrazePromoCodeEvent(promoCode);
                let successCallback;
                const promo = store.getState().promo;
                const sampleSkuIdList = promo.msgPromosSkuList;

                if (isBccPromotionComponent && !isBasketOrCheckoutPage) {
                    successCallback = () => showPromoConfirmationModal();
                }

                store.dispatch(Actions.showPromoModal(
                    true,
                    items,
                    maxMsgSkusToSelect,
                    instructions,
                    promoCode,
                    location,
                    successCallback
                ));
            } else {
                // Fire only if success Don't fire for Promo Modal Load
                store.dispatch(BasketActions.updateBasket(data));
                Promos.sendBrazePromoCodeEvent(promoCode);

                const analyticsData = Promos.getBasicAnalyticsData(promoCode);
                analyticsData.userInput = appliedPromotions.map(({ couponCode }) => couponCode).join(',').toLowerCase();
                if (titleText) {
                    analyticsData.internalCampaign= `beauty offers:${titleText}:apply`;
                }
                processEvent.process(LINK_TRACKING_EVENT, { data: analyticsData });

                promoPopUpErrorMessages = basketLevelMessages.filter(msg => (
                    msg.type === ERROR &&
                    msg.messageContext === PROMO_INVALID &&
                    ErrorsUtils.isFormattedError(msg.messages[0])
                ));

                if (promoPopUpErrorMessages.length > 0) {
                    Promos.showWarningMessage(promoPopUpErrorMessages[0].messages[0]);
                }

                const { sku: promoSku, qty: promoQty } = items[items.length-1];
                const { skuId, productName, brandName, displayName, listPrice } = promoSku;
                const priceForGoogle = listPrice === 'FREE' ? '0.00' : listPrice;

                let googleAnalyticsChangedBasketData = {
                    id: skuId,
                    name: productName,
                    brand: brandName || '',
                    variant: displayName,
                    quantity: promoQty || 1,
                    price: priceForGoogle
                };
                
                addToCartPixels.googleAnalyticsAddToBasketEvent(googleAnalyticsChangedBasketData);

                if (isBccPromotionComponent && !isBasketOrCheckoutPage) {
                    showPromoConfirmationModal();
                }
            }
        }).catch(reason => {
            if (userUtils.isAnonymous()) {
                store.dispatch(UtilActions.merge('promo', 'afterLogin', [promoCode, null, appliedAt]));
            }

            const { errorMessages } = reason;
            // require.ensure is used to package nested requires in components.chunk.js
            // rather than priority.bundle.js in order to keep priority.bundle.js lean
            require.ensure([], function (require) {
                const analyticsData = Promos.getBasicAnalyticsData(promoCode, true);
                const linkTrackingError = require('analytics/bindings/pages/all/linkTrackingError');
                const { CTA_TYPES: { TEXT } } = Promos;
                const fieldErrors = (isBccPromotionComponent && !isBasketOrCheckoutPage) ? ['beauty offers promo'] : ['promo'];
                const data = {
                    ...analyticsData,
                    bindingMethods: [linkTrackingError],
                    serverResponse: (appliedAt === TEXT && !isBasketOrCheckoutPage) ? errorMessages : 'D=c48',
                    fieldErrors,
                    errorMessages
                };
                processEvent.process(LINK_TRACKING_EVENT, { data });
            }, 'components');

            store.dispatch(
                UtilActions.merge('promo', 'promoError', Object.assign({}, reason, {
                    appliedAt,
                    promoCode
                }))
            );

            if ((isBccPromotionComponent || Location.isBIPage()) && !isBasketOrCheckoutPage) {
                const title = getText('promoErrorTitle');
                const message = errorMessages[0];
                const buttonText = getText('ok');
                store.dispatch(Actions.showInfoModal({
                    isOpen: true,
                    title,
                    message,
                    buttonText,
                    dataAtTitle: 'promo_reward_warning_label',
                    dataAtMessage: 'promo_reward_warning_msg',
                    dataAtButton: 'warning_popup_ok_button',
                    dataAtClose: 'close_warning_popup'
                }));
            }

            return reason;
        });
}
function ensureSinglePromoAction(promoAction, promoCode) {
    return (...args) => {
        if (!promoCode) {
            return promoAction && promoAction(...args);
        }
        if (Promos.promosInProgress) {
            return Promise.resolve();
        }
        return promoAction(...args);
    };
}

function fireRemovePromoAnalytics(promoCode) {
    processEvent.process(LINK_TRACKING_EVENT, {
        data: {
            eventStrings: ['event71'],
            linkName: 'remove promo code',
            actionInfo: 'remove promo code'
        }
    });
}

function removePromotion(couponCode, appliedAt = Promos.CTA_TYPES.TEXT) {
    const orderId = basketUtils.getOrderId();
    const BasketActions = require('actions/BasketActions');

    return decorators.withInterstice(
        basketApi.removePromotion,
        checkoutConstants.INTERSTICE_DELAY_MS
    )(orderId, couponCode).then(data => {
        data.promoWarning = data.promoWarning ? data.promoWarning : null;
        data.appliedPromotions = data.appliedPromotions ? data.appliedPromotions : [];
        store.dispatch(PromoActions.removeMsgPromosByCode(couponCode));
        store.dispatch(BasketActions.updateBasket(data));
        if (Promos.isPfdPromoCode(couponCode) || Promos.isCbrPromoCode(couponCode)) {
            fireRemovePromoAnalytics();
        }
    }).catch(reason => store.dispatch(
        UtilActions.merge('promo', 'promoError', Object.assign({}, reason, {
            appliedAt,
            promoCode: couponCode
        }))
    ));
}

const Promos = {

    FIRST_INCENTIVE_DISCOUNT: 'firstbuypercentoff',

    ERROR_CODES: {
        PROMO_ERROR: -1,
        PROMO_OVER_LIMIT: -2
    },

    PROMO_TYPES: {
        PROMO: 'PROMO',
        CCR: 'CCR',
        CBR: 'CBR',
        PFD: 'PFD'
    },

    CTA_TYPES: {
        TEXT: 'TEXT',
        CCR: 'CCR',
        CBR: 'CBR',
        PFD: 'PFD'
    },

    getPromoType(couponCode = '') {
        return [
            [this.PROMO_TYPES.CCR, this.isRewardPromoCode.bind(this)],
            [this.PROMO_TYPES.CBR, this.isCbrPromoCode.bind(this)],
            [this.PROMO_TYPES.PFD, this.isPfdPromoCode.bind(this)],
            [this.PROMO_TYPES.PROMO, () => true]
        ].find(v => v[1](couponCode))[0];
    },

    isRewardPromoCode: function (couponCode = '') {
        couponCode = couponCode.toLowerCase();
        return couponCode.indexOf('rw') === 0 || couponCode === this.FIRST_INCENTIVE_DISCOUNT;
    },

    isCbrPromoCode: function (couponCode = '') {
        return couponCode.toLowerCase().indexOf('cbr') === 0;
    },

    isPfdPromoCode: function (couponCode = '') {
        return couponCode.toLowerCase().indexOf('pfd') === 0;
    },

    isRrcPromoCode: function (couponCode = '') {
        return couponCode.toLowerCase().indexOf('rrc') === 0;
    },

    getAppliedPromoCodes: function (type = this.PROMO_TYPES.PROMO) {
        let appliedPromos = this.getAppliedPromotions(type);
        let promoCodes = [];
        if (appliedPromos && appliedPromos.length) {
            appliedPromos.map((promo) => promoCodes.push(promo.couponCode));
        }
        return promoCodes;
    },

    getAppliedPromotions: function (type = this.PROMO_TYPES.PROMO, data) {

        let appliedPromotions = [];
        if (!data) {
            const isCheckout = Location.isCheckout();
            if (isCheckout) {
                const order = store.getState().order;
                if (order && order.orderDetails && order.orderDetails.promotion) {
                    appliedPromotions = order.orderDetails.promotion.appliedPromotions;
                }
            } else {
                const basket = basketUtils.getCurrentBasketData();
                if (basket && basket.appliedPromotions) {
                    appliedPromotions = basket.appliedPromotions;
                }
            }
        } else {
            appliedPromotions = data.appliedPromotions;
        }
        return this.filterPromotions(appliedPromotions, type);
    },

    filterPromotions: function (appliedPromotions = [], type) {
        if (!appliedPromotions || !appliedPromotions.length) {
            return [];
        }
        switch (type) {
            case this.PROMO_TYPES.CCR:
                return appliedPromotions
                    .filter(promo => this.isRewardPromoCode(promo.couponCode));
            case this.PROMO_TYPES.CBR:
                return appliedPromotions
                    .filter(promo => this.isCbrPromoCode(promo.couponCode));
            case this.PROMO_TYPES.PROMO:
                return appliedPromotions
                    .filter(promo => !this.isRewardPromoCode(promo.couponCode))
                    .filter(promo => !this.isCbrPromoCode(promo.couponCode));
            default:
                return appliedPromotions;
        }
    },

    getCCPromoDetails: function (isCheckout = false) {
        const items = isCheckout ?
            store.getState().order.orderDetails.items :
            basketUtils.getCurrentBasketData();
        return items.creditCardPromoDetails;
    },

    extractError(promo = {}, ctaTypes = []) {
        const error = promo.promoError || {};
        const hasCtaType = ctaTypes.some(type => error.appliedAt === type);

        if (error.errorMessages && error.promoCode && hasCtaType) {
            return error;
        }

        return {};
    },

    promosInProgress: false,

    ensureSinglePromoAction: ensureSinglePromoAction,

    applyPromo: function (...args) {
        return ensureSinglePromoAction(applyPromotion, args[0])(...args);
    },

    removePromo: function (...args) {
        return ensureSinglePromoAction(removePromotion, args[0])(...args);
    },

    submitMsgPromos: function (...args) {
        return new Promise((resolve, reject)=>{
            basketApi.addMsgPromotionToBasket(...args)
                .then((data)=>{  
                    resolve(data);
                })
                .catch((error) => {
                    if (Location.isBasketPage() || Location.isCheckout()) {
                        store.dispatch(PromoActions.removeMsgPromosByCode(args[0]));
                        store.dispatch(
                            UtilActions.merge('promo', 'promoError', { ...error, promoCode: args[0] })
                        );
                    } else {
                        let getText = localeUtils.getLocaleResourceFile('utils/locales', 'Promos');
                        const title = getText('promoErrorTitle');
                        const message = error.errorMessages;
                        const buttonText = getText('ok');
                        store.dispatch(Actions.showInfoModal({
                            isOpen: true,
                            title,
                            message,
                            buttonText,
                            dataAtTitle: 'promo_reward_warning_label',
                            dataAtMessage: 'promo_reward_warning_msg',
                            dataAtButton: 'warning_popup_ok_button',
                            dataAtClose: 'close_warning_popup'
                        }));
                    }
                    reject(error);
                });
        });
           
    },

    showWarningMessage: function (message) {
        const getText = localeUtils.getLocaleResourceFile('utils/locales', 'Promos');
        const title = getText('promoWarning');
        const buttonText = getText('ok');

        store.dispatch(Actions.showInfoModal({
            isOpen: true,
            title: title,
            message: message,
            buttonText: buttonText, 
            dataAt: 'promo_warning_popup',
            dataAtTitle: 'promo_warning_title',
            dataAtMessage: 'promo_warning_message'
        }));
    },

    sendBrazePromoCodeEvent: sendBrazePromoCodeEvent,
    getBasicAnalyticsData: getBasicAnalyticsData,
    applyPromotion: applyPromotion
};

module.exports = Promos;
